import { KeysHeader } from 'components/keySelection/KeyHeader'
import { Navbar } from 'components/navigation/Navbar'

function Layout({ children }: any) {
  return (
    <>
      <Navbar />
      <div className='relative md:ml-[230px] md:max-w-[calc(100vw-230px)]'>
        <KeysHeader />
        {children}
      </div>
    </>
  )
}

export default Layout
